import React, { memo } from "react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

function PaginationComponent({
  currentPage = 0,
  totalItems = 0,
  total = 0,
  pageSize = 10,
  handlePrevPage,
  handleNextPage,
  loading = false,
}) {
  const { t } = useTranslation();

  const totalPage = useMemo(
    () => Math.ceil(total / pageSize),
    [total, pageSize]
  );
  const currentTotalItems = useMemo(
    () => {
      if (total <= 0)
        return 0;

      return (currentPage - 1) * pageSize + 1;
    },

    [total, currentPage, pageSize]
  );

  const currentPageItems = useMemo(
    () => {
      if (total <= 0)
        return 0;


      const defaultPageItems = ((currentPage - 1) * pageSize) + pageSize;

      return defaultPageItems > total ? total : defaultPageItems;
    },

    [total, currentPage, pageSize]
  );

  return (
    <div className="d-flex flex-col align-items-center justify-content-end gap-4 mr-5">
      <div className="d-flex justify-content-center">
        {currentTotalItems > 0 ? (
          <>
            {t("Showing")} {currentTotalItems} -{" "}
            {currentPageItems} {t("of")} {total} {t("tickets")}
          </>
        ) : (
          <>
            {t("Showing")} {currentTotalItems}
            {" "}
            {t("of")} {total} {t("tickets")}
          </>
        )
        }

      </div>
      <Pagination
        aria-label="agents-founded"
        className="d-flex justify-content-around mt-2"
      >
        <PaginationItem
          onClick={handlePrevPage}
          disabled={currentPage === 1 || loading}
        >
          <PaginationLink previous />
        </PaginationItem>

        <PaginationItem className="page-item-fixed-size" active={total > 0}>
          <PaginationLink> {currentPage} </PaginationLink>
        </PaginationItem>

        <PaginationItem
          onClick={handleNextPage}
          disabled={currentPage >= totalPage || loading}
        >
          <PaginationLink next />
        </PaginationItem>
      </Pagination>
    </div>
  );
}

export default memo(PaginationComponent);
